import React, { useState } from "react";
// redux
import { useDispatch } from "react-redux";
import { change } from "redux-form";

// material-ui
import makeStyles from "@material-ui/styles/makeStyles";
// material-ui-core
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";

// icon
import ActionCancel from "@material-ui/icons/Cancel";

import { CheckboxGroupInput, SelectInput, Button, SaveButton, PageFooter, SimpleForm, BooleanInput, NumberInput, TextInput, regex } from "jazasoft";
//helper
import { isEmpty } from "../../utils/helpers";

const useStyles = makeStyles(_ => ({
  title: {
    margin: 0,
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: "0.25em"
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end"
  }
}));

const EditDialog = ({ open, setting = {}, onClose, onSubmit }) => {
  // state
  const [selectAll, setSelectAll] = useState(false);

  const dispatch = useDispatch();
  const classes = useStyles();

  const choices = setting.dataType === "select" || setting.dataType === "select-multiple" ? JSON.parse(setting.choices || "[]") : [];

  const record = {
    ...setting,
    value:
      setting.dataType === "select-multiple"
        ? setting.value?.split(",").map(e => e.trim()) || []
        : setting.dataType?.toLowerCase().trim() === "boolean"
        ? setting.value === "true" || setting.value === true
        : setting.value
  };

  const onChange = event => {
    const value = event.target.checked;
    if (value === true) {
      dispatch(
        change(
          "record-form",
          "value",
          choices.map(e => e.id)
        )
      );
    } else {
      dispatch(change("record-form", "value", []));
    }
    setSelectAll(value);
  };

  const onSave = values => {
    if (setting.dataType === "select-multiple") {
      const { value } = values;
      const valList = value?.filter(e => !isEmpty(e));
      const finalValue = choices
        .filter(c => valList.includes(c.id))
        .map(e => e.id)
        .join(", ");
      const data = { ...setting, value: finalValue };
      onSubmit(data);
    } else {
      onSubmit(values);
    }
  };

  if (isEmpty(setting) || !open) return <div></div>;

  return (
    <Dialog id="edit-dialog" fullWidth={true} maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle disableTypography className={classes.title}>
        <Typography variant="h6">{setting.name || ""}</Typography>
        {setting.dataType === "select-multiple" && (
          <FormControlLabel control={<Switch checked={selectAll} onChange={onChange} color="primary" />} label="Select All" />
        )}
      </DialogTitle>

      <Divider />
      <DialogContent id="edit-dialog-content">
        <SimpleForm
          record={record}
          onSubmit={onSave}
          i18nKey="settings"
          footer={props => (
            <PageFooter>
              <SaveButton {...props} label="js.action.submit" />
              <Button label="js.action.cancel" onClick={onClose} variant="contained">
                <ActionCancel />
              </Button>
            </PageFooter>
          )}>
          {setting.dataType === "select-multiple" && <CheckboxGroupInput className={classes.checkBox} source="value" choices={choices} />}
          {setting.dataType === "select" && <SelectInput label={setting && setting.name} source="value" xs={12} fullWidth choices={choices} />}

          {setting.dataType === "boolean" && <BooleanInput label={setting && setting.name} source="value" xs={12} fullWidth />}
          {setting.dataType === "number" && (
            <NumberInput label={setting && setting.name} source="value" xs={12} fullWidth options={{ fullWidth: true }} />
          )}
          {(setting.dataType === "text" || setting.dataType === "text-json") && (
            <TextInput
              label={setting && setting.name}
              source="value"
              xs={12}
              fullWidth
              multiline={setting.dataType === "text-json" ? true : undefined}
              options={{ fullWidth: true }}
              validate={!isEmpty(setting.regex) ? regex(new RegExp(setting.regex), setting.regexError) : undefined}
            />
          )}
        </SimpleForm>
      </DialogContent>
    </Dialog>
  );
};

export default EditDialog;
